import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MibBadgeComponent, MibIconsModule } from '@medinbox/angular';
import { MibLogo } from './mib-logo';
import { LivekitService } from '../../core/services/livekit.service';

@Component({
  selector: 'app-mib-header',
  imports: [MibLogo, MibBadgeComponent, MibIconsModule],
  templateUrl: './medinbox-header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MedinboxHeader {
  private readonly livekit = inject(LivekitService);
  readonly isReady = this.livekit.isReady;
}
